<!--
 * @description: 首页图片
 * @param: 
 * @return: 
-->
<template>
  <div class="echarts-list">
    <div class="echarts-main">
      <!-- 堆叠折线图 -->
      <div class="echarts-container">
        <div class="title-area select-options" :style="titleBg">
          <span>每月报修量</span>
          <div v-if="flag == '1'" class="select-option-list">
            <el-select v-model="customSelect" class="m-2" placeholder="客户选择" size="small" filterable
              @change="handleCustormSelect">
              <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
        </div>
        <div class="echarts-test" ref="echartsTest"></div>
      </div>
    </div>
    <!-- 饼状图 -->
    <div class="echarts-pie-container">
      <div class="title-area" :style="titleBg">
        <div class="zdsb-sty ">站点设备</div>
        <div class="total-container">
          <span class="num-area">{{ count }}</span>
          <span>台</span>
        </div>
      </div>

      <div class="echarts-pie" ref="echartsPie"></div>
    </div>

    <!-- <div class="infor-container">
      <div class="title-box">
        <div class="text">
          最新消息
          <span class="number">{{ inforTotal }}</span>
        </div>
      </div>
      <div class="content-box">
        <el-carousel height="200px" direction="vertical" :autoplay="true" interval="6000">
          <el-carousel-item v-for="item in infoList" :key="item.id">
            <div class="content-list" v-for="(i, index) in item.item" :key="i.Id" @click="infoClick(i)">
              <div class="timer">{{ i.AddDate }}</div>
              <div class="content-text">
                <span>
                  <i class="el-icon-chat-dot-round"></i>
                </span>
                <span :class="{ unread: !i.IsReadLine }">消息通知:{{ i.Messagex }}</span>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div> -->

    <el-dialog v-model="dialogVisible" width="30%" center title="消息通知">
      <div>{{ inforConcat }}</div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import panelContainer from "@/components/panelContainer.vue";
import field from "@/components/textField.vue";
import searchButton from "@/components/searchButton.vue";
import cardPanel from "@/components/cardPanel.vue";
import chart from "@/components/vChart.vue";
import tabelApi from "@/api/tabel.js";
import // getToolsTimes,
  // payBackTimes,
  // orgEachUninWarehouseInfo,
  // warehouseInfo
  "@/api/index.js";
import { errMsg } from "@/notify/index.js";
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  getCurrentInstance,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import tabel from "@/api/tabel.js";
export default defineComponent({
  name: "ChartReports",
  components: {
    panelContainer,
    field,
    searchButton,
    cardPanel,
    chart,
  },
  props: {
    titleBg: Object,
  },
  setup() {
    let router = useRouter();
    const { proxy } = getCurrentInstance();
    let data = reactive({
      inforConcat: "",
      infoList: [],
      dialogVisible: false,
      selectOptions: null,
      flag: null,
      customSelect: "",
      echartsTest: null,
      option: {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // 图列的配置
          type: "scroll",
          bottom: "-3%",
          left: "0%",
          data: ["Email", "Union Ads", "Video Ads", "Direct"],
        },
        grid: {
          //用来设置x y的宽高（距离canvas）
          left: "0",
          top: "8%",
          right: "2%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],

          axisLabel: {
            interval: 0, // 用来控制显示x轴显示的 刻度间隔，零表示每个都显示。
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "Email",
            type: "line",
            // stack: "Total",
            data: [120, 132, 101, 134, 90, 230, 210, 110, 220, 55, 66, 77],
          },
          {
            name: "Union Ads",
            type: "line",
            // stack: "Total",
            data: [220, 182, 191, 234, 290, 330, 310, 120, 132, 101, 134, 90],
          },
          {
            name: "Video Ads",
            type: "line",
            // stack: "Total",
            data: [150, 232, 201, 154, 190, 330, 410, 201, 154, 190, 330, 10],
          },
          {
            name: "Direct",
            type: "line",
            // stack: "Total",
            data: [320, 332, 301, 334, 390, 330, 320, 230, 154, 190, 330, 10],
          },
        ],
      },
    });
    let datas = reactive({
      echartsPie: null,
      count: 0,
      option: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          // 图列的配置
          type: "scroll",
          bottom: "-3%",
          left: "0%",
          data: ['TC57', 'MC3200', 'LS3578', 'CV61', 'PC42t'],
        },
        series: [
          {
            type: "pie",
            top: '0',
            radius: ['40%', '80%'],
            label: {
              //标签
              show: false,
            },
            labelLine: {
              // 标签牵引线
              show: false,
            },
            data: [
              { value: 0, name: "TC57" },
              { value: 0, name: "MC3200" },
              { value: 0, name: "LS3578" },
              { value: 0, name: "CV61" },
              { value: 0, name: "PC42t" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    });

    onMounted(() => {
      //  proxy.$websocket= ;
      // const ws = proxy.$websocket;
      // ws.send("获取信息");
      // ws.onmessage = function (evt) {
        // console.log(evt, "message");
        // const { data: dat } = evt;
        // const res = JSON.parse(dat);
        // const infoArr = [
        //   { item: [...res.slice(0, 3)], id: 1 },
        //   { item: [...res.slice(3, 6)], id: 2 },
        //   { item: [...res.slice(6, 9)], id: 3 },
        //   { item: [...res.slice(9, 12)], id: 4 },
        // ];
        // data.infoList = infoArr.filter((i) => i.item.length);
        // data.inforTotal=res.filter(i=>!i.IsReadLine).length
        // debugger
        // console.log(res, "res----websocket");
        // ws.close();
      // }

      methods.getRepairAmount();
      methods.getCompanyInfoesData();
      methods.getPieData();
      // methods.concontWs();
    });

    // 使用计算属性
    let inforTotal = computed(() => {
      let index = 0;
      const arr = data.infoList;
      arr.forEach((o) => {
        o.item.forEach((i) => {
          if (!i.IsReadLine) {
            index++;
          }
        });
      });
      return index;
    });
    let methods = {
      getCompanyInfoesData() {
        tabel.CompanyInfo().then((res) => {
          console.log(res);
          data.selectOptions = res.data?.list?.map((item) => ({
            label: item.CompName,
            value: item.Company_Id,
          }));
        });
      },
      getRepairAmount(CompnyId = null) {
        // 月报数据请求
        tabel.VisRepaiCount({ CompnyId }).then((res) => {
          console.log(res, "repairamout");
          const {
            data: { list, flag },
          } = res;
          const { option } = data;
          data.flag = flag;
          if (!list.length) {
            errMsg("选择的客户暂未有数据");
            data.customSelect = "";
            return;
          }
          option.legend.data = list.map((item) => item.ModelNoStr); //更改线条名称和数量
          option.series = list.map((item) => {
            return {
              name: item.ModelNoStr,
              type: "line",
              data: [
                item.Jan,
                item.February,
                item.March,
                item.April,
                item.May,
                item.June,
                item.July,
                item.August,
                item.September,
                item.October,
                item.November,
                item.December,
              ],
            };
          });
          const myEchart = echarts.init(data.echartsTest);
          myEchart.setOption(data.option);
        });
      },
      getPieData() {
        // 饼图数据请求
        tabelApi.VisSnZHanCount().then((res) => {
          console.log(res, "pieres");
          const {
            data: { list },
          } = res;
          if (list.length) {
            datas.option.series[0].data = list.map((i) => ({
              value: i.Countt,
              name: i.ModelNoStr,
              ModelNoId:i.Id
            }));
            datas.option.legend.data=list.map(i=>i.ModelNoStr)
            datas.count = list.reduce((pre, i) => {
              return (pre += i.Countt);
            }, 0);
          }

          const pieEchart = echarts.init(datas.echartsPie);
          pieEchart.setOption(datas.option);
          pieEchart.on("click",(v)=>{
            console.log(v,"绑定饼图点击事件")
            router.push({
              path: "/home/serviceSN",
              query:{ModelNoId:v.data.ModelNoId}
            });
            
          })
        });
      },
      handleCustormSelect(v) {
        console.log(v, "vv");
        methods.getRepairAmount(v);
      },
      infoClick(i) {
        data.dialogVisible = true;
        data.inforConcat = i.Messagex;
        console.log(i, "ii");
        tabelApi.MessageReadLine({ Id: i.Id });
        i.IsReadLine = 1;
      },
    };

    return {
      inforTotal,
      ...toRefs(data),
      ...toRefs(datas),
      ...methods,
    };
  },
});
</script>

<style lang="scss" scoped>
.echarts-list {
  display: flex;
  justify-content: space-between;

  .echarts-main,.echarts-pie-container {
    background-color: white;
    width: 49.8%;
    height: 320px;
    // overflow: hidden;
    border: 0.005208rem solid #cccccc;
    border-radius: 6px;

    .echarts-container {
      // width: 49%;
      // height: auto;
      // padding: 15px 0;

      // overflow: hidden;
      .title-area {
        padding: 0 20px;
        font-size: 20px;
        width: 100%;
        height: 32px;
        line-height: 32px;
        border-bottom: 2px solid rgb(233, 233, 233);
        
        color: #323232;
      }

      .select-options {
        display: flex;

        .select-option-list {
          margin-left: 40px;
        }
      }

      .echarts-test {
        padding: 0 20px;
        width: 100%;
        height: 270px;
      }
    }
  }

  .echarts-pie-container {
    // width: 341px;
    height: 320px;
    // margin-left:60px;
    position: relative;
    background-color: white;
    // padding: 15px 0;

    .title-area {
      padding: 0 20px;
      // font-size: 20px;
      width: 100%;
      height: 32px;
      line-height: 32px;
      border-bottom: 2px solid rgb(233, 233, 233);
      display:flex;
      justify-content: space-between;
  // .zdsb-sty{
  //    font-size: 20px;
  // }
      .total-container {
        // width: 100%;
        // height: 30px;
        // position: absolute;
        // top: 72px;
        // left: 120px;
        font-size: 20px;
        font-weight: normal;
        .num-area {
          display: inline-block;
          width: 50px;
          text-align: center;
          margin-right: 5px;
          font-size: 22px;
          color: red;
          
        }
      }
    }

    .echarts-pie {
      //饼状图
      // margin:0 auto;
      width: 100%;
      height: 270px;
    }
  }

  .infor-container {
    height: 363px;
    width: 300px;
    position: relative;
    background-color: white;
    padding: 15px 0;

    .title-box {
      padding: 0 20px;
      font-size: 20px;
      width: 100%;
      height: 42px;
      line-height: 42px;
      border-bottom: 2px solid rgb(233, 233, 233);
      margin-bottom: 14px;

      .number {
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: red;
        box-shadow: 5px 5px 3px #888888;
        display: inline-block;
        position: relative;
        border-radius: 50%;
        top: -6px;
        right: 8px;
        color: white;
      }
    }

    .content-box {
      .content-list {
        height: 76px;
        border-bottom: 1px solid rgb(233, 233, 233);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 0 10px;
        margin-top: 4px;

        .timer {
          //时间
          font-size: 18px;
          color: #999;
        }

        .content-text {
          //内容区域
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 20px;
        }
      }
    }
  }
}

// :deep(.el-carousel__indicator--vertical .el-carousel__button) {
//   background-color: rgb(39, 114, 65);
// }

.unread {
  color: red;
}
</style>
